import styled from 'foundations-theming/utils';
import { Logo } from 'foundations-components/transitional/components/Logo';
import { AVATAR_SIZES, SOCIAL_MAP } from '../../Constants';
import { jsx as _jsx } from "react/jsx-runtime";
const SOCIAL_BADGE_PADDING_SIZES = {
  xxs: '50',
  xs: '50',
  sm: '50',
  md: '100',
  lg: '100',
  xl: '200',
  responsive: '0'
};
const SocialBadgeWrapper = styled.div.withConfig({
  displayName: "SocialBadge__SocialBadgeWrapper"
})(["", ""], ({
  theme,
  showBackground
}) => ({
  position: 'absolute',
  right: '-16%',
  bottom: '-1%',
  backgroundColor: showBackground ? theme.color['fill-surface-default'] : undefined,
  borderRadius: showBackground ? theme.borderRadius['400'] : undefined,
  lineHeight: '0'
}));
const SocialBadge = ({
  socialNetwork,
  size
}) => {
  const {
    logoName,
    showBackground
  } = SOCIAL_MAP[socialNetwork];
  if (!logoName || size === 'responsive') {
    return null;
  }
  const padding = SOCIAL_BADGE_PADDING_SIZES[size];
  const badgeSize = Math.round(AVATAR_SIZES[size] * 0.5);
  const sizeValue = `${badgeSize}px`;
  return /*#__PURE__*/_jsx(SocialBadgeWrapper, {
    showBackground: showBackground,
    "data-test-id": "avatar-social-badge",
    "data-avatar-name": socialNetwork,
    children: /*#__PURE__*/_jsx(Logo, {
      name: logoName,
      width: sizeValue,
      height: sizeValue,
      padding: padding
    })
  });
};
export default SocialBadge;